/* ============================================================
   TEMPORALIS — B2B CONFIGURATOR i18n
   tpls-b2b-i18n.js  (upload as Shopify asset)
   ============================================================
   Convention: product tag B2B_TYPE:classic | metallic | glitter |
   glow | jagua drives the type label (type_<code>).

   v10 CHANGE LOG (vs v9) — requires configurator v16:
     - err_cart: shown under the CTA when the options can't be added
       (the tattoo line is then removed again).
     - prop_backing* / prop_packaging* are no longer sent by v16 (options
       are their own cart lines); kept for older configurators.

   v9 CHANGE LOG (vs v8) — requires configurator v14:
     - Prices shown excl. VAT first. New keys in every locale:
       ht_suffix (HT, zzgl. MwSt., sin IVA…), ttc_suffix (TTC,
       inkl. MwSt., IVA incl.…) and vat_note ({rate} = the VAT
       rate of the storefront country, set by the configurator).
     - cta_order no longer carries a tax label: the configurator
       fills {price} with "net (gross)", e.g.
       "Commander — 145,83 € HT (175,00 € TTC)".
     - per_unit is no longer read by v14 (kept for v13).
     - en_us: prices are tax-exclusive in the US market, so the
       labels read "excl. tax" (the old "incl. tax" was false).

   v8 CHANGE LOG (vs v7):
     - Professional register everywhere: the configurator only ever
       renders on B2B product pages, so the consumer "tu/du/din/teu"
       forms are gone. Register per locale matches the B2B pages:
       fr vous · de Sie · it voi · nl u · es usted · pl Państwo ·
       sv ni/er · da I/jeres · pt third person ("o seu").
     - Type labels aligned with the product pages (they show in the
       summary AND in the cart line item): fr Métallisé / Paillettes /
       Quadrichromie, es Metalizado / Purpurina / A todo color,
       pt Metalizado / Purpurina / Quadricromia, it Quadricromia,
       de Glitzer / Vollfarbe / Glow-in-the-Dark, nl Full colour,
       sv Fyrfärg, da Fuldfarve, pl Pełny kolor, en Full colour.
     - "tattoos" -> the local word (tatouages, tatuajes, tatuaggi,
       tatuagens); "Backing" -> the local word for the back (dos,
       Rückseite, reverso, retro, achterkant, bagside, baksida,
       odwrocie, verso).
     - de: card_glow_title and type_glow now use the same term
       (they read "Nachtleuchtend" vs "Nachleuchtend").
     - UV card/type label: "UV" + the local name of the blacklight
       (lumière noire, luce di Wood, luz negra, svartljus…).
     - en_gb: British spelling (Customise, finalise).
     - th: unchanged (not part of the B2B localisation pass).

   v7 CHANGE LOG (vs v6):
     - Henna dropped from the range (no B2B market, see the research
       note of 18/09), so type_henna and the whole colour option go:
       option_colour_label, colour_black/brown/white/red.
       option_finish_label stays — it labels the glow Finish cards.

   v6 CHANGE LOG (vs v5):
     - Added keys for the secondary option (glow Finish):
       option_finish_label, type_uv_fluo. No new mechanism —
       type_uv_fluo reuses the type_<code> lookup pattern.

   v5 CHANGE LOG (vs v4):
     - type_water_transfer and type_classic_colourful merged into a
       single type_classic (same product line under two names).

   v4 CHANGE LOG (vs v3):
     - addon_included_from reworded from "Included from X" to "Free
       from X": "included" falsely implies the perk is applied even
       when the client has unchecked the toggle.

   v3 CHANGE LOG (vs v2):
     - backing_default / backing_label / backing_hint simplified:
       no co-branding claim. What goes on the back is settled with
       the client after checkout.

   v2 CHANGE LOG (vs v1):
     - Packaging add-on keys, addon_included_from and
       upsell_addon_free added in all locales.
   ============================================================ */
window._tplsB2bI18nAll = {

/* ---- ENGLISH (international, default) ---- */
en: {
  step_format: 'Format',
  step_quantity: 'Quantity',
  step_design: 'Your design',
  from: 'From',
  per_unit: '/unit incl. VAT',
  qty_per_unit: '/unit',
  upload_cta: '+ Drop your design here',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max 20 MB',
  upload_ok: '✓ File selected',
  upload_remove: '+ Drop your design here',
  err_file_type: 'File type .{ext} not accepted. Use: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'File too large ({size} MB). Maximum: 20 MB.',
  guidelines_link: 'Design guidelines & templates ↓',
  or_email: 'or email',
  backing_default: 'By default, the back carries the {brand} branding + application instructions.',
  backing_label: 'Customize the back',
  backing_hint: '✓ We\'ll follow up after your order to finalize the details',
  packaging_default: 'By default, tattoos ship bundled together.',
  packaging_label: 'Wrap each tattoo individually',
  packaging_hint: '✓ Each tattoo sealed in its own sleeve, ready to hand out one by one',
  addon_included_from: 'Free from {qty} pieces',
  summary_tattoos: 'tattoos',
  summary_backing: 'Custom backing',
  summary_packaging: 'Individual packaging',
  summary_shipping: 'Free shipping',
  cta_order: 'Place order — {price}',
  ht_suffix: 'excl. VAT',
  ttc_suffix: 'incl. VAT',
  err_cart: 'Your order could not be added to the cart. Please try again.',
  vat_note: 'Prices excl. VAT. The total paid at checkout includes {rate}% VAT.',
  cta_uploading: 'Uploading…',
  upsell_header: 'Order more, pay less',
  upsell_addon_free: '+ options included free',
  modal_title: 'Volume pricing',
  modal_showing: '▸ Showing prices for {size}',
  modal_th_qty: 'Qty',
  modal_th_unit: 'Unit price',
  modal_th_total: 'Total',
  modal_note: '● = price tier change. Intermediate quantities use the previous tier\'s unit price.',
  prop_backing_custom: 'Custom backing requested',
  prop_backing_default: 'Temporalis default',
  prop_packaging_yes: 'Individually wrapped',
  prop_packaging_no: 'Bundled',
  prop_design_file: 'Design file',
  prop_backing: 'Backing',
  prop_packaging: 'Packaging',
  type_metallic: 'Metallic',
  type_glitter: 'Glitter',
  type_glow: 'Glow in the Dark',
  type_jagua: 'Jagua',
  type_classic: 'Full colour',
  cta_choose_first: 'Choose an option above',
  option_choose_title: 'Which one do you need?',
  card_glow_title: 'Glow in the dark',
  card_glow_need: 'No equipment',
  card_glow_desc: 'Charges in light, glows on its own in the dark.',
  card_uv_fluo_title: 'UV / blacklight',
  card_uv_fluo_need: 'UV lamps required',
  card_uv_fluo_desc: 'Neon by day, intense under blacklight only.',
  option_finish_label: 'Finish',
  type_uv_fluo: 'UV / blacklight',
},

/* ---- FRENCH (vous) ---- */
fr: {
  step_format: 'Format',
  step_quantity: 'Quantité',
  step_design: 'Votre visuel',
  from: 'À partir de',
  per_unit: '/unité TTC',
  qty_per_unit: '/unité',
  upload_cta: '+ Déposez votre visuel ici',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max. 20 Mo',
  upload_ok: '✓ Fichier sélectionné',
  upload_remove: '+ Déposez votre visuel ici',
  err_file_type: 'Type de fichier .{ext} non accepté. Formats acceptés : PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Fichier trop lourd ({size} Mo). Maximum : 20 Mo.',
  guidelines_link: 'Guide de préparation et gabarits ↓',
  or_email: 'ou par e-mail',
  backing_default: 'Par défaut, le dos porte la marque Temporalis et les instructions d\'application.',
  backing_label: 'Personnaliser le dos',
  backing_hint: '✓ Nous revenons vers vous après la commande pour finaliser les détails',
  packaging_default: 'Par défaut, les tatouages sont expédiés groupés.',
  packaging_label: 'Emballer chaque tatouage individuellement',
  packaging_hint: '✓ Chaque tatouage scellé dans son propre sachet, prêt à être distribué un par un',
  addon_included_from: 'Gratuit dès {qty} pièces',
  summary_tattoos: 'tatouages',
  summary_backing: 'Dos personnalisé',
  summary_packaging: 'Emballage individuel',
  summary_shipping: 'Livraison gratuite',
  cta_order: 'Commander — {price}',
  ht_suffix: 'HT',
  ttc_suffix: 'TTC',
  err_cart: 'L\'ajout au panier n\'a pas abouti. Merci de réessayer.',
  vat_note: 'Prix HT. Le total réglé au paiement inclut la TVA de {rate} %.',
  cta_uploading: 'Envoi en cours…',
  upsell_header: 'Plus de volume, meilleur prix',
  upsell_addon_free: '+ options incluses gratuitement',
  modal_title: 'Tarifs dégressifs',
  modal_showing: '▸ Prix pour le format {size}',
  modal_th_qty: 'Qté',
  modal_th_unit: 'Prix unitaire',
  modal_th_total: 'Total',
  modal_note: '● = changement de palier tarifaire. Les quantités intermédiaires gardent le prix du palier précédent.',
  prop_backing_custom: 'Dos personnalisé demandé',
  prop_backing_default: 'Temporalis par défaut',
  prop_packaging_yes: 'Emballé individuellement',
  prop_packaging_no: 'Groupé',
  prop_design_file: 'Fichier du visuel',
  prop_backing: 'Dos',
  prop_packaging: 'Emballage',
  type_metallic: 'Métallisé',
  type_glitter: 'Paillettes',
  type_glow: 'Phosphorescent',
  type_jagua: 'Jagua',
  type_classic: 'Quadrichromie',
  cta_choose_first: 'Choisissez une option ci-dessus',
  option_choose_title: 'Quelle finition vous faut-il ?',
  card_glow_title: 'Phosphorescent',
  card_glow_need: 'Sans équipement',
  card_glow_desc: 'Se charge à la lumière, brille seul dans le noir.',
  card_uv_fluo_title: 'UV (lumière noire)',
  card_uv_fluo_need: 'Lampes UV requises',
  card_uv_fluo_desc: 'Fluo le jour, intense sous lumière noire seulement.',
  option_finish_label: 'Finition',
  type_uv_fluo: 'UV (lumière noire)',
},

/* ---- GERMAN (Sie) ---- */
de: {
  step_format: 'Format',
  step_quantity: 'Menge',
  step_design: 'Ihr Motiv',
  from: 'Ab',
  per_unit: '/Stück inkl. MwSt.',
  qty_per_unit: '/Stück',
  upload_cta: '+ Motiv hier ablegen',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max. 20 MB',
  upload_ok: '✓ Datei ausgewählt',
  upload_remove: '+ Motiv hier ablegen',
  err_file_type: 'Dateityp .{ext} wird nicht akzeptiert. Zulässig: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Datei zu groß ({size} MB). Maximum: 20 MB.',
  guidelines_link: 'Druckdaten-Guide & Vorlagen ↓',
  or_email: 'oder per E-Mail',
  backing_default: 'Standardmäßig trägt die Rückseite das Temporalis-Branding und die Anwendungshinweise.',
  backing_label: 'Rückseite individualisieren',
  backing_hint: '✓ Wir melden uns nach Ihrer Bestellung, um die Details zu klären',
  packaging_default: 'Standardmäßig werden die Tattoos gebündelt versendet.',
  packaging_label: 'Jedes Tattoo einzeln verpacken',
  packaging_hint: '✓ Jedes Tattoo einzeln versiegelt, bereit zum Verteilen',
  addon_included_from: 'Kostenlos ab {qty} Stück',
  summary_tattoos: 'Tattoos',
  summary_backing: 'Individuelle Rückseite',
  summary_packaging: 'Einzelverpackung',
  summary_shipping: 'Kostenloser Versand',
  cta_order: 'Bestellen — {price}',
  ht_suffix: 'zzgl. MwSt.',
  ttc_suffix: 'inkl. MwSt.',
  err_cart: 'Die Bestellung konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.',
  vat_note: 'Nettopreise. Der an der Kasse gezahlte Betrag enthält {rate} % MwSt.',
  cta_uploading: 'Wird hochgeladen…',
  upsell_header: 'Mehr bestellen, weniger zahlen',
  upsell_addon_free: '+ Optionen kostenlos inklusive',
  modal_title: 'Mengenpreise',
  modal_showing: '▸ Preise für {size}',
  modal_th_qty: 'Menge',
  modal_th_unit: 'Stückpreis',
  modal_th_total: 'Gesamt',
  modal_note: '● = Preisstufe. Zwischenmengen behalten den Preis der vorherigen Stufe.',
  prop_backing_custom: 'Individuelle Rückseite gewünscht',
  prop_backing_default: 'Temporalis Standard',
  prop_packaging_yes: 'Einzeln verpackt',
  prop_packaging_no: 'Gebündelt',
  prop_design_file: 'Motivdatei',
  prop_backing: 'Rückseite',
  prop_packaging: 'Verpackung',
  type_metallic: 'Metallic',
  type_glitter: 'Glitzer',
  type_glow: 'Glow-in-the-Dark',
  type_jagua: 'Jagua',
  type_classic: 'Vollfarbe',
  cta_choose_first: 'Bitte oben eine Option wählen',
  option_choose_title: 'Welche Ausführung brauchen Sie?',
  card_glow_title: 'Glow-in-the-Dark',
  card_glow_need: 'Ohne Technik',
  card_glow_desc: 'Lädt sich im Licht auf, leuchtet im Dunkeln von selbst.',
  card_uv_fluo_title: 'UV / Schwarzlicht',
  card_uv_fluo_need: 'UV-Lampen nötig',
  card_uv_fluo_desc: 'Tagsüber Neon, intensiv nur unter Schwarzlicht.',
  option_finish_label: 'Ausführung',
  type_uv_fluo: 'UV / Schwarzlicht',
},

/* ---- SPANISH (usted) ---- */
es: {
  step_format: 'Formato',
  step_quantity: 'Cantidad',
  step_design: 'Su diseño',
  from: 'Desde',
  per_unit: '/unidad IVA incl.',
  qty_per_unit: '/unidad',
  upload_cta: '+ Arrastre su diseño aquí',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — máx. 20 MB',
  upload_ok: '✓ Archivo seleccionado',
  upload_remove: '+ Arrastre su diseño aquí',
  err_file_type: 'Tipo de archivo .{ext} no admitido. Formatos: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Archivo demasiado grande ({size} MB). Máximo: 20 MB.',
  guidelines_link: 'Guía de preparación y plantillas ↓',
  or_email: 'o por correo',
  backing_default: 'Por defecto, el reverso lleva la marca Temporalis y las instrucciones de aplicación.',
  backing_label: 'Personalizar el reverso',
  backing_hint: '✓ Nos pondremos en contacto tras su pedido para concretar los detalles',
  packaging_default: 'Por defecto, los tatuajes se envían agrupados.',
  packaging_label: 'Envasar cada tatuaje individualmente',
  packaging_hint: '✓ Cada tatuaje sellado en su propia bolsita, listo para repartir uno a uno',
  addon_included_from: 'Gratis desde {qty} unidades',
  summary_tattoos: 'tatuajes',
  summary_backing: 'Reverso personalizado',
  summary_packaging: 'Envasado individual',
  summary_shipping: 'Envío gratis',
  cta_order: 'Hacer pedido — {price}',
  ht_suffix: 'sin IVA',
  ttc_suffix: 'IVA incl.',
  err_cart: 'No se ha podido añadir el pedido a la cesta. Inténtelo de nuevo.',
  vat_note: 'Precios sin IVA. El total pagado al finalizar el pedido incluye un {rate} % de IVA.',
  cta_uploading: 'Subiendo…',
  upsell_header: 'Más cantidad, mejor precio',
  upsell_addon_free: '+ opciones incluidas gratis',
  modal_title: 'Precios por volumen',
  modal_showing: '▸ Precios para {size}',
  modal_th_qty: 'Cant.',
  modal_th_unit: 'Precio unitario',
  modal_th_total: 'Total',
  modal_note: '● = cambio de tarifa. Las cantidades intermedias mantienen el precio del tramo anterior.',
  prop_backing_custom: 'Reverso personalizado solicitado',
  prop_backing_default: 'Temporalis por defecto',
  prop_packaging_yes: 'Envasado individualmente',
  prop_packaging_no: 'Agrupado',
  prop_design_file: 'Archivo de diseño',
  prop_backing: 'Reverso',
  prop_packaging: 'Envasado',
  type_metallic: 'Metalizado',
  type_glitter: 'Purpurina',
  type_glow: 'Fosforescente',
  type_jagua: 'Jagua',
  type_classic: 'A todo color',
  cta_choose_first: 'Elija una opción arriba',
  option_choose_title: '¿Cuál necesita?',
  card_glow_title: 'Fosforescente',
  card_glow_need: 'Sin equipo',
  card_glow_desc: 'Se carga con la luz, brilla solo en la oscuridad.',
  card_uv_fluo_title: 'UV (luz negra)',
  card_uv_fluo_need: 'Lámparas UV',
  card_uv_fluo_desc: 'Neón de día, intenso solo bajo luz negra.',
  option_finish_label: 'Acabado',
  type_uv_fluo: 'UV (luz negra)',
},

/* ---- ITALIAN (voi) ---- */
it: {
  step_format: 'Formato',
  step_quantity: 'Quantità',
  step_design: 'La vostra grafica',
  from: 'A partire da',
  per_unit: '/unità IVA incl.',
  qty_per_unit: '/unità',
  upload_cta: '+ Trascinate qui la vostra grafica',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max 20 MB',
  upload_ok: '✓ File selezionato',
  upload_remove: '+ Trascinate qui la vostra grafica',
  err_file_type: 'Tipo di file .{ext} non accettato. Formati: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'File troppo grande ({size} MB). Massimo: 20 MB.',
  guidelines_link: 'Guida ai file e tracciati ↓',
  or_email: 'o via e-mail',
  backing_default: 'Di serie, il retro riporta il marchio Temporalis e le istruzioni di applicazione.',
  backing_label: 'Personalizzare il retro',
  backing_hint: '✓ Vi contattiamo dopo l\'ordine per definire i dettagli',
  packaging_default: 'Di serie, i tatuaggi vengono spediti raggruppati.',
  packaging_label: 'Confezionare ogni tatuaggio singolarmente',
  packaging_hint: '✓ Ogni tatuaggio sigillato nella sua bustina, pronto da distribuire uno a uno',
  addon_included_from: 'Gratis da {qty} pezzi',
  summary_tattoos: 'tatuaggi',
  summary_backing: 'Retro personalizzato',
  summary_packaging: 'Confezione individuale',
  summary_shipping: 'Spedizione gratuita',
  cta_order: 'Ordina — {price}',
  ht_suffix: 'IVA esclusa',
  ttc_suffix: 'IVA inclusa',
  err_cart: 'Non è stato possibile aggiungere l\'ordine al carrello. Riprovate.',
  vat_note: 'Prezzi IVA esclusa. Il totale pagato al checkout include l\'IVA al {rate}%.',
  cta_uploading: 'Caricamento…',
  upsell_header: 'Più volume, prezzo migliore',
  upsell_addon_free: '+ opzioni incluse gratis',
  modal_title: 'Prezzi per volume',
  modal_showing: '▸ Prezzi per {size}',
  modal_th_qty: 'Qtà',
  modal_th_unit: 'Prezzo unitario',
  modal_th_total: 'Totale',
  modal_note: '● = cambio di fascia. Le quantità intermedie mantengono il prezzo della fascia precedente.',
  prop_backing_custom: 'Retro personalizzato richiesto',
  prop_backing_default: 'Temporalis predefinito',
  prop_packaging_yes: 'Confezionato singolarmente',
  prop_packaging_no: 'Raggruppato',
  prop_design_file: 'File della grafica',
  prop_backing: 'Retro',
  prop_packaging: 'Confezione',
  type_metallic: 'Metallizzato',
  type_glitter: 'Glitter',
  type_glow: 'Fosforescente',
  type_jagua: 'Jagua',
  type_classic: 'Quadricromia',
  cta_choose_first: 'Scegliete un\'opzione qui sopra',
  option_choose_title: 'Quale vi serve?',
  card_glow_title: 'Fosforescente',
  card_glow_need: 'Senza impianti',
  card_glow_desc: 'Si carica alla luce, brilla da solo al buio.',
  card_uv_fluo_title: 'UV (luce di Wood)',
  card_uv_fluo_need: 'Lampade UV',
  card_uv_fluo_desc: 'Fluo di giorno, intenso solo sotto luce di Wood.',
  option_finish_label: 'Finitura',
  type_uv_fluo: 'UV (luce di Wood)',
},

/* ---- DUTCH (u) ---- */
nl: {
  step_format: 'Formaat',
  step_quantity: 'Aantal',
  step_design: 'Uw ontwerp',
  from: 'Vanaf',
  per_unit: '/stuk incl. btw',
  qty_per_unit: '/stuk',
  upload_cta: '+ Sleep uw ontwerp hierheen',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max. 20 MB',
  upload_ok: '✓ Bestand geselecteerd',
  upload_remove: '+ Sleep uw ontwerp hierheen',
  err_file_type: 'Bestandstype .{ext} wordt niet geaccepteerd. Toegestaan: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Bestand te groot ({size} MB). Maximum: 20 MB.',
  guidelines_link: 'Aanleverspecificaties & sjablonen ↓',
  or_email: 'of per e-mail',
  backing_default: 'Standaard staan op de achterkant de Temporalis-branding en de gebruiksaanwijzing.',
  backing_label: 'Achterkant bedrukken',
  backing_hint: '✓ Na uw bestelling nemen we contact op om de details af te stemmen',
  packaging_default: 'Standaard worden de tattoos gebundeld verzonden.',
  packaging_label: 'Elke tattoo apart verpakken',
  packaging_hint: '✓ Elke tattoo verzegeld in een eigen zakje, klaar om één voor één uit te delen',
  addon_included_from: 'Gratis vanaf {qty} stuks',
  summary_tattoos: 'tattoos',
  summary_backing: 'Bedrukte achterkant',
  summary_packaging: 'Individuele verpakking',
  summary_shipping: 'Gratis verzending',
  cta_order: 'Bestellen — {price}',
  ht_suffix: 'excl. btw',
  ttc_suffix: 'incl. btw',
  err_cart: 'Uw bestelling kon niet aan de winkelwagen worden toegevoegd. Probeer het opnieuw.',
  vat_note: 'Prijzen excl. btw. Het totaal bij het afrekenen is inclusief {rate}% btw.',
  cta_uploading: 'Bezig met uploaden…',
  upsell_header: 'Meer bestellen, minder betalen',
  upsell_addon_free: '+ opties gratis inbegrepen',
  modal_title: 'Staffelprijzen',
  modal_showing: '▸ Prijzen voor {size}',
  modal_th_qty: 'Aantal',
  modal_th_unit: 'Stukprijs',
  modal_th_total: 'Totaal',
  modal_note: '● = prijsstaffel. Tussenliggende aantallen behouden de prijs van de vorige staffel.',
  prop_backing_custom: 'Bedrukte achterkant aangevraagd',
  prop_backing_default: 'Temporalis standaard',
  prop_packaging_yes: 'Apart verpakt',
  prop_packaging_no: 'Gebundeld',
  prop_design_file: 'Ontwerpbestand',
  prop_backing: 'Achterkant',
  prop_packaging: 'Verpakking',
  type_metallic: 'Metallic',
  type_glitter: 'Glitter',
  type_glow: 'Glow-in-the-dark',
  type_jagua: 'Jagua',
  type_classic: 'Full colour',
  cta_choose_first: 'Kies hierboven een optie',
  option_choose_title: 'Welke heeft u nodig?',
  card_glow_title: 'Glow-in-the-dark',
  card_glow_need: 'Zonder apparatuur',
  card_glow_desc: 'Laadt op in het licht, licht vanzelf op in het donker.',
  card_uv_fluo_title: 'UV (blacklight)',
  card_uv_fluo_need: 'UV-lampen nodig',
  card_uv_fluo_desc: 'Overdag neon, intens alleen onder blacklight.',
  option_finish_label: 'Afwerking',
  type_uv_fluo: 'UV (blacklight)',
},

/* ---- DANISH (I/jeres) ---- */
da: {
  step_format: 'Format',
  step_quantity: 'Antal',
  step_design: 'Jeres motiv',
  from: 'Fra',
  per_unit: '/stk. inkl. moms',
  qty_per_unit: '/stk.',
  upload_cta: '+ Træk jeres motiv hertil',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — maks. 20 MB',
  upload_ok: '✓ Fil valgt',
  upload_remove: '+ Træk jeres motiv hertil',
  err_file_type: 'Filtypen .{ext} accepteres ikke. Tilladt: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Filen er for stor ({size} MB). Maks.: 20 MB.',
  guidelines_link: 'Filguide & skabeloner ↓',
  or_email: 'eller via e-mail',
  backing_default: 'Som standard har bagsiden Temporalis-branding og brugsanvisningen.',
  backing_label: 'Tryk på bagsiden',
  backing_hint: '✓ Vi kontakter jer efter bestillingen for at aftale detaljerne',
  packaging_default: 'Som standard sendes tatoveringerne samlet.',
  packaging_label: 'Enkeltpak hver tatovering',
  packaging_hint: '✓ Hver tatovering forseglet i sin egen pose, klar til uddeling én ad gangen',
  addon_included_from: 'Gratis fra {qty} stk.',
  summary_tattoos: 'tatoveringer',
  summary_backing: 'Tryk på bagsiden',
  summary_packaging: 'Enkeltpakning',
  summary_shipping: 'Gratis fragt',
  cta_order: 'Bestil — {price}',
  ht_suffix: 'ekskl. moms',
  ttc_suffix: 'inkl. moms',
  err_cart: 'Bestillingen kunne ikke lægges i kurven. Prøv venligst igen.',
  vat_note: 'Priser ekskl. moms. Beløbet ved betaling er inkl. {rate} % moms.',
  cta_uploading: 'Uploader…',
  upsell_header: 'Bestil flere, betal mindre',
  upsell_addon_free: '+ tilvalg inkluderet gratis',
  modal_title: 'Mængdepriser',
  modal_showing: '▸ Priser for {size}',
  modal_th_qty: 'Antal',
  modal_th_unit: 'Stykpris',
  modal_th_total: 'Total',
  modal_note: '● = prisskift. Mellemliggende mængder beholder prisen fra forrige trin.',
  prop_backing_custom: 'Tryk på bagsiden ønsket',
  prop_backing_default: 'Temporalis standard',
  prop_packaging_yes: 'Enkeltpakket',
  prop_packaging_no: 'Samlet',
  prop_design_file: 'Motivfil',
  prop_backing: 'Bagside',
  prop_packaging: 'Emballage',
  type_metallic: 'Metallic',
  type_glitter: 'Glitter',
  type_glow: 'Selvlysende',
  type_jagua: 'Jagua',
  type_classic: 'Fuldfarve',
  cta_choose_first: 'Vælg en mulighed ovenfor',
  option_choose_title: 'Hvilken har I brug for?',
  card_glow_title: 'Selvlysende',
  card_glow_need: 'Uden udstyr',
  card_glow_desc: 'Lader op i lys, lyser af sig selv i mørke.',
  card_uv_fluo_title: 'UV (black light)',
  card_uv_fluo_need: 'UV-lamper kræves',
  card_uv_fluo_desc: 'Neon om dagen, intenst kun under black light.',
  option_finish_label: 'Udførelse',
  type_uv_fluo: 'UV (black light)',
},

/* ---- SWEDISH (ni/er) ---- */
sv: {
  step_format: 'Format',
  step_quantity: 'Antal',
  step_design: 'Er design',
  from: 'Från',
  per_unit: '/st inkl. moms',
  qty_per_unit: '/st',
  upload_cta: '+ Dra er design hit',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max 20 MB',
  upload_ok: '✓ Fil vald',
  upload_remove: '+ Dra er design hit',
  err_file_type: 'Filtypen .{ext} accepteras inte. Tillåtna: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Filen är för stor ({size} MB). Max: 20 MB.',
  guidelines_link: 'Filguide & mallar ↓',
  or_email: 'eller via e-post',
  backing_default: 'Som standard har baksidan Temporalis-branding och appliceringsinstruktionerna.',
  backing_label: 'Tryck på baksidan',
  backing_hint: '✓ Vi hör av oss efter er beställning för att bestämma detaljerna',
  packaging_default: 'Som standard skickas tatueringarna buntade tillsammans.',
  packaging_label: 'Styckförpacka varje tatuering',
  packaging_hint: '✓ Varje tatuering förseglad i en egen påse, redo att delas ut en och en',
  addon_included_from: 'Gratis från {qty} st',
  summary_tattoos: 'tatueringar',
  summary_backing: 'Tryck på baksidan',
  summary_packaging: 'Styckförpackning',
  summary_shipping: 'Fri frakt',
  cta_order: 'Beställ — {price}',
  ht_suffix: 'exkl. moms',
  ttc_suffix: 'inkl. moms',
  err_cart: 'Beställningen kunde inte läggas i varukorgen. Försök igen.',
  vat_note: 'Priser exkl. moms. Beloppet i kassan inkluderar {rate} % moms.',
  cta_uploading: 'Laddar upp…',
  upsell_header: 'Beställ fler, betala mindre',
  upsell_addon_free: '+ tillval ingår gratis',
  modal_title: 'Mängdpriser',
  modal_showing: '▸ Priser för {size}',
  modal_th_qty: 'Antal',
  modal_th_unit: 'Styckpris',
  modal_th_total: 'Totalt',
  modal_note: '● = prisändring. Mellanliggande antal behåller priset från föregående steg.',
  prop_backing_custom: 'Tryck på baksidan önskas',
  prop_backing_default: 'Temporalis standard',
  prop_packaging_yes: 'Styckförpackad',
  prop_packaging_no: 'Buntad',
  prop_design_file: 'Designfil',
  prop_backing: 'Baksida',
  prop_packaging: 'Förpackning',
  type_metallic: 'Metallic',
  type_glitter: 'Glitter',
  type_glow: 'Självlysande',
  type_jagua: 'Jagua',
  type_classic: 'Fyrfärg',
  cta_choose_first: 'Välj ett alternativ ovan',
  option_choose_title: 'Vilken behöver ni?',
  card_glow_title: 'Självlysande',
  card_glow_need: 'Utan utrustning',
  card_glow_desc: 'Laddas i ljus, lyser av sig själv i mörker.',
  card_uv_fluo_title: 'UV (svartljus)',
  card_uv_fluo_need: 'UV-lampor krävs',
  card_uv_fluo_desc: 'Neon på dagen, intensivt bara under svartljus.',
  option_finish_label: 'Utförande',
  type_uv_fluo: 'UV (svartljus)',
},

/* ---- POLISH (Państwo) ---- */
pl: {
  step_format: 'Format',
  step_quantity: 'Ilość',
  step_design: 'Państwa wzór',
  from: 'Od',
  per_unit: '/szt. z VAT',
  qty_per_unit: '/szt.',
  upload_cta: '+ Proszę przeciągnąć wzór tutaj',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — maks. 20 MB',
  upload_ok: '✓ Plik wybrany',
  upload_remove: '+ Proszę przeciągnąć wzór tutaj',
  err_file_type: 'Typ pliku .{ext} nie jest akceptowany. Dozwolone: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Plik jest za duży ({size} MB). Maksymalnie: 20 MB.',
  guidelines_link: 'Wytyczne do pliku i szablony ↓',
  or_email: 'lub e-mailem',
  backing_default: 'Domyślnie na odwrocie znajduje się marka Temporalis i instrukcja aplikacji.',
  backing_label: 'Nadruk na odwrocie',
  backing_hint: '✓ Po złożeniu zamówienia skontaktujemy się, aby ustalić szczegóły',
  packaging_default: 'Domyślnie tatuaże są wysyłane w zbiorczym opakowaniu.',
  packaging_label: 'Pakowanie każdego tatuażu osobno',
  packaging_hint: '✓ Każdy tatuaż zamknięty w osobnej torebce, gotowy do rozdania sztuka po sztuce',
  addon_included_from: 'Gratis od {qty} szt.',
  summary_tattoos: 'tatuaży',
  summary_backing: 'Nadruk na odwrocie',
  summary_packaging: 'Pakowanie indywidualne',
  summary_shipping: 'Darmowa dostawa',
  cta_order: 'Zamawiam — {price}',
  ht_suffix: 'netto',
  ttc_suffix: 'brutto',
  err_cart: 'Nie udało się dodać zamówienia do koszyka. Prosimy spróbować ponownie.',
  vat_note: 'Ceny netto. Kwota do zapłaty zawiera {rate}% VAT.',
  cta_uploading: 'Przesyłanie…',
  upsell_header: 'Większy nakład, niższa cena',
  upsell_addon_free: '+ opcje gratis w cenie',
  modal_title: 'Cennik ilościowy',
  modal_showing: '▸ Ceny dla {size}',
  modal_th_qty: 'Ilość',
  modal_th_unit: 'Cena jedn.',
  modal_th_total: 'Razem',
  modal_note: '● = zmiana progu cenowego. Ilości pośrednie zachowują cenę z poprzedniego progu.',
  prop_backing_custom: 'Nadruk na odwrocie zamówiony',
  prop_backing_default: 'Temporalis domyślnie',
  prop_packaging_yes: 'Pakowane pojedynczo',
  prop_packaging_no: 'Zbiorczo',
  prop_design_file: 'Plik wzoru',
  prop_backing: 'Odwrocie',
  prop_packaging: 'Pakowanie',
  type_metallic: 'Metaliczny',
  type_glitter: 'Brokatowy',
  type_glow: 'Świecący w ciemności',
  type_jagua: 'Jagua',
  type_classic: 'Pełny kolor',
  cta_choose_first: 'Proszę wybrać opcję powyżej',
  option_choose_title: 'Którego wykończenia Państwo potrzebują?',
  card_glow_title: 'Świecący w ciemności',
  card_glow_need: 'Bez sprzętu',
  card_glow_desc: 'Ładuje się w świetle, świeci sam w ciemności.',
  card_uv_fluo_title: 'UV (światło ultrafioletowe)',
  card_uv_fluo_need: 'Wymaga lamp UV',
  card_uv_fluo_desc: 'W dzień neon, intensywnie tylko w świetle UV.',
  option_finish_label: 'Wykończenie',
  type_uv_fluo: 'UV (światło ultrafioletowe)',
},

/* ---- PORTUGUESE (PT, third person) ---- */
pt: {
  step_format: 'Formato',
  step_quantity: 'Quantidade',
  step_design: 'O seu desenho',
  from: 'A partir de',
  per_unit: '/unidade IVA incl.',
  qty_per_unit: '/unidade',
  upload_cta: '+ Arraste o seu desenho para aqui',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — máx. 20 MB',
  upload_ok: '✓ Ficheiro selecionado',
  upload_remove: '+ Arraste o seu desenho para aqui',
  err_file_type: 'Tipo de ficheiro .{ext} não aceite. Formatos: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'Ficheiro demasiado grande ({size} MB). Máximo: 20 MB.',
  guidelines_link: 'Guia de preparação e modelos ↓',
  or_email: 'ou por e-mail',
  backing_default: 'Por defeito, o verso tem a marca Temporalis e as instruções de aplicação.',
  backing_label: 'Personalizar o verso',
  backing_hint: '✓ Entramos em contacto depois da sua encomenda para acertar os pormenores',
  packaging_default: 'Por defeito, as tatuagens são enviadas agrupadas.',
  packaging_label: 'Embalar cada tatuagem individualmente',
  packaging_hint: '✓ Cada tatuagem selada na sua própria saqueta, pronta a distribuir uma a uma',
  addon_included_from: 'Grátis a partir de {qty} unidades',
  summary_tattoos: 'tatuagens',
  summary_backing: 'Verso personalizado',
  summary_packaging: 'Embalagem individual',
  summary_shipping: 'Envio grátis',
  cta_order: 'Encomendar — {price}',
  ht_suffix: 'sem IVA',
  ttc_suffix: 'IVA incl.',
  err_cart: 'Não foi possível adicionar a encomenda ao carrinho. Tente novamente.',
  vat_note: 'Preços sem IVA. O total pago no checkout inclui IVA à taxa de {rate} %.',
  cta_uploading: 'A enviar…',
  upsell_header: 'Mais quantidade, melhor preço',
  upsell_addon_free: '+ opções incluídas grátis',
  modal_title: 'Preços por volume',
  modal_showing: '▸ Preços para {size}',
  modal_th_qty: 'Qtd.',
  modal_th_unit: 'Preço unitário',
  modal_th_total: 'Total',
  modal_note: '● = mudança de escalão. As quantidades intermédias mantêm o preço do escalão anterior.',
  prop_backing_custom: 'Verso personalizado pedido',
  prop_backing_default: 'Temporalis padrão',
  prop_packaging_yes: 'Embalado individualmente',
  prop_packaging_no: 'Agrupado',
  prop_design_file: 'Ficheiro do desenho',
  prop_backing: 'Verso',
  prop_packaging: 'Embalagem',
  type_metallic: 'Metalizado',
  type_glitter: 'Purpurina',
  type_glow: 'Fosforescente',
  type_jagua: 'Jagua',
  type_classic: 'Quadricromia',
  cta_choose_first: 'Escolha uma opção acima',
  option_choose_title: 'Qual precisa?',
  card_glow_title: 'Fosforescente',
  card_glow_need: 'Sem equipamento',
  card_glow_desc: 'Carrega com a luz, brilha sozinho no escuro.',
  card_uv_fluo_title: 'UV (luz negra)',
  card_uv_fluo_need: 'Lâmpadas UV',
  card_uv_fluo_desc: 'Néon de dia, intenso só sob luz negra.',
  option_finish_label: 'Acabamento',
  type_uv_fluo: 'UV (luz negra)',
},

/* ---- THAI (unchanged in v8) ---- */
th: {
  step_format: 'ขนาด',
  step_quantity: 'จำนวน',
  step_design: 'อัปโหลดดีไซน์',
  from: 'เริ่มต้น',
  per_unit: '/ชิ้น รวม VAT',
  qty_per_unit: '/ชิ้น',
  upload_cta: '+ ลากไฟล์มาวางที่นี่',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — สูงสุด 20 MB',
  upload_ok: '✓ เลือกไฟล์แล้ว',
  upload_remove: '+ ลากไฟล์มาวางที่นี่',
  err_file_type: 'ไม่รองรับไฟล์ .{ext} ใช้: PDF, AI, EPS, SVG, PNG, JPG',
  err_file_size: 'ไฟล์ใหญ่เกินไป ({size} MB) สูงสุด: 20 MB',
  guidelines_link: 'คู่มือออกแบบ & เทมเพลต ↓',
  or_email: 'หรืออีเมล',
  backing_default: 'ค่าเริ่มต้น ด้านหลังมีแบรนด์ Temporalis + คำแนะนำการใช้งาน',
  backing_label: 'ปรับแต่งด้านหลัง',
  backing_hint: '✓ เราจะติดต่อกลับหลังสั่งซื้อเพื่อสรุปรายละเอียด',
  packaging_default: 'ค่าเริ่มต้น แทททูจัดส่งรวมกันเป็นชุด',
  packaging_label: 'ห่อแทททูแยกชิ้น',
  packaging_hint: '✓ แทททูแต่ละชิ้นถูกปิดผนึกแยกซอง พร้อมแจกทีละชิ้น',
  addon_included_from: 'ฟรีตั้งแต่ {qty} ชิ้น',
  summary_tattoos: 'ชิ้น',
  summary_backing: 'Backing ส่วนตัว',
  summary_packaging: 'บรรจุภัณฑ์แยกชิ้น',
  summary_shipping: 'จัดส่งฟรี',
  cta_order: 'สั่งซื้อ — {price}',
  ht_suffix: 'ไม่รวม VAT',
  ttc_suffix: 'รวม VAT',
  err_cart: 'ไม่สามารถเพิ่มคำสั่งซื้อลงตะกร้าได้ กรุณาลองอีกครั้ง',
  vat_note: 'ราคาไม่รวม VAT ยอดที่ชำระตอนเช็กเอาต์รวม VAT {rate}%',
  cta_uploading: 'กำลังอัปโหลด…',
  upsell_header: 'สั่งเยอะ ยิ่งถูก',
  upsell_addon_free: '+ ตัวเลือกฟรี',
  modal_title: 'ราคาตามจำนวน',
  modal_showing: '▸ ราคาสำหรับ {size}',
  modal_th_qty: 'จำนวน',
  modal_th_unit: 'ราคา/ชิ้น',
  modal_th_total: 'รวม',
  modal_note: '● = เปลี่ยนระดับราคา จำนวนระหว่างขั้นใช้ราคาของขั้นก่อนหน้า',
  prop_backing_custom: 'ขอปรับแต่งด้านหลัง',
  prop_backing_default: 'Temporalis มาตรฐาน',
  prop_packaging_yes: 'บรรจุแยกชิ้น',
  prop_packaging_no: 'รวมกัน',
  prop_design_file: 'ไฟล์ดีไซน์',
  prop_backing: 'Backing',
  prop_packaging: 'บรรจุภัณฑ์',
  type_metallic: 'เมทัลลิก',
  type_glitter: 'กลิตเตอร์',
  type_glow: 'เรืองแสงในที่มืด',
  type_jagua: 'จากัว',
  type_classic: 'คลาสสิกสี',
  cta_choose_first: 'เลือกตัวเลือกด้านบน',
  option_choose_title: 'ต้องการแบบไหน?',
  card_glow_title: 'เรืองแสงในที่มืด',
  card_glow_need: 'ไม่ต้องใช้อุปกรณ์',
  card_glow_desc: 'ชาร์จแสงแล้วเรืองแสงเองในที่มืด',
  card_uv_fluo_title: 'ยูวี (แบล็กไลท์)',
  card_uv_fluo_need: 'ต้องมีไฟยูวี',
  card_uv_fluo_desc: 'กลางวันสีนีออน เรืองแสงเฉพาะใต้แบล็กไลท์',
  option_finish_label: 'ลักษณะ',
  type_uv_fluo: 'ยูวี (แบล็กไลท์)',
},

/* ---- EN-US ---- */
en_us: {
  step_format: 'Size',
  step_quantity: 'Quantity',
  step_design: 'Your design',
  from: 'From',
  per_unit: '/unit incl. tax',
  qty_per_unit: '/unit',
  upload_cta: '+ Drop your design here',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max 20 MB',
  upload_ok: '✓ File selected',
  upload_remove: '+ Drop your design here',
  err_file_type: 'File type .{ext} not accepted. Use: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'File too large ({size} MB). Maximum: 20 MB.',
  guidelines_link: 'Design guidelines & templates ↓',
  or_email: 'or email',
  backing_default: 'By default, the back carries the Temporalis branding + application instructions.',
  backing_label: 'Customize the back',
  backing_hint: '✓ We\'ll follow up after your order to finalize the details',
  packaging_default: 'By default, tattoos ship bundled together.',
  packaging_label: 'Wrap each tattoo individually',
  packaging_hint: '✓ Each tattoo sealed in its own sleeve, ready to hand out one by one',
  addon_included_from: 'Free from {qty} pieces',
  summary_tattoos: 'tattoos',
  summary_backing: 'Custom backing',
  summary_packaging: 'Individual packaging',
  summary_shipping: 'Free shipping',
  cta_order: 'Place order — {price}',
  ht_suffix: 'excl. tax',
  ttc_suffix: 'incl. tax',
  err_cart: 'Your order could not be added to the cart. Please try again.',
  vat_note: 'Prices excl. tax. The total paid at checkout includes {rate}% tax.',
  cta_uploading: 'Uploading…',
  upsell_header: 'Order more, pay less',
  upsell_addon_free: '+ options included free',
  modal_title: 'Volume pricing',
  modal_showing: '▸ Showing prices for {size}',
  modal_th_qty: 'Qty',
  modal_th_unit: 'Unit price',
  modal_th_total: 'Total',
  modal_note: '● = price tier change. Intermediate quantities use the previous tier\'s unit price.',
  prop_backing_custom: 'Custom backing requested',
  prop_backing_default: 'Temporalis default',
  prop_packaging_yes: 'Individually wrapped',
  prop_packaging_no: 'Bundled',
  prop_design_file: 'Design file',
  prop_backing: 'Backing',
  prop_packaging: 'Packaging',
  type_metallic: 'Metallic',
  type_glitter: 'Glitter',
  type_glow: 'Glow in the Dark',
  type_jagua: 'Jagua',
  type_classic: 'Full color',
  cta_choose_first: 'Choose an option above',
  option_choose_title: 'Which one do you need?',
  card_glow_title: 'Glow in the dark',
  card_glow_need: 'No equipment',
  card_glow_desc: 'Charges in light, glows on its own in the dark.',
  card_uv_fluo_title: 'UV / blacklight',
  card_uv_fluo_need: 'UV lamps required',
  card_uv_fluo_desc: 'Neon by day, intense under blacklight only.',
  option_finish_label: 'Finish',
  type_uv_fluo: 'UV / blacklight',
},

/* ---- EN-GB ---- */
en_gb: {
  step_format: 'Size',
  step_quantity: 'Quantity',
  step_design: 'Your design',
  from: 'From',
  per_unit: '/unit incl. VAT',
  qty_per_unit: '/unit',
  upload_cta: '+ Drop your design here',
  upload_specs: 'PDF · AI · EPS · SVG · PNG · JPG — max 20 MB',
  upload_ok: '✓ File selected',
  upload_remove: '+ Drop your design here',
  err_file_type: 'File type .{ext} not accepted. Use: PDF, AI, EPS, SVG, PNG, JPG.',
  err_file_size: 'File too large ({size} MB). Maximum: 20 MB.',
  guidelines_link: 'Design guidelines & templates ↓',
  or_email: 'or email',
  backing_default: 'By default, the back carries the Temporalis branding + application instructions.',
  backing_label: 'Customise the back',
  backing_hint: '✓ We\'ll follow up after your order to finalise the details',
  packaging_default: 'By default, tattoos ship bundled together.',
  packaging_label: 'Wrap each tattoo individually',
  packaging_hint: '✓ Each tattoo sealed in its own sleeve, ready to hand out one by one',
  addon_included_from: 'Free from {qty} pieces',
  summary_tattoos: 'tattoos',
  summary_backing: 'Custom backing',
  summary_packaging: 'Individual packaging',
  summary_shipping: 'Free delivery',
  cta_order: 'Place order — {price}',
  ht_suffix: 'excl. VAT',
  ttc_suffix: 'incl. VAT',
  err_cart: 'Your order could not be added to the basket. Please try again.',
  vat_note: 'Prices excl. VAT. The total paid at checkout includes {rate}% VAT.',
  cta_uploading: 'Uploading…',
  upsell_header: 'Order more, pay less',
  upsell_addon_free: '+ options included free',
  modal_title: 'Volume pricing',
  modal_showing: '▸ Showing prices for {size}',
  modal_th_qty: 'Qty',
  modal_th_unit: 'Unit price',
  modal_th_total: 'Total',
  modal_note: '● = price tier change. Intermediate quantities use the previous tier\'s unit price.',
  prop_backing_custom: 'Custom backing requested',
  prop_backing_default: 'Temporalis default',
  prop_packaging_yes: 'Individually wrapped',
  prop_packaging_no: 'Bundled',
  prop_design_file: 'Design file',
  prop_backing: 'Backing',
  prop_packaging: 'Packaging',
  type_metallic: 'Metallic',
  type_glitter: 'Glitter',
  type_glow: 'Glow in the Dark',
  type_jagua: 'Jagua',
  type_classic: 'Full colour',
  cta_choose_first: 'Choose an option above',
  option_choose_title: 'Which one do you need?',
  card_glow_title: 'Glow in the dark',
  card_glow_need: 'No equipment',
  card_glow_desc: 'Charges in light, glows on its own in the dark.',
  card_uv_fluo_title: 'UV / blacklight',
  card_uv_fluo_need: 'UV lamps required',
  card_uv_fluo_desc: 'Neon by day, intense under blacklight only.',
  option_finish_label: 'Finish',
  type_uv_fluo: 'UV / blacklight',
}

};